import React, {memo} from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { oneDark } from 'react-syntax-highlighter/dist/esm/styles/prism';
import CopyContent from "./CopyContent"

interface MessageProps {
  typing: boolean;
  index: number;
  content: string | undefined;
  role: "user" | "assistant";
  messageLength: number;
}

const Message: React.FC<MessageProps> = ({ typing, content, role, messageLength, index }) => {
  return (
    <div
      style={{
        backgroundColor: "#F9F9F9",
        color: "#ECECF1",
        textAlign: "left",
        display: "flex",
        alignItems: "flex-start",
        whiteSpace: "pre-line",
        padding: "10px 15%",
        marginBottom: '2px'
      }}
    >
      <div className={role === "user" ? "col" : "bot-text-container col"}>
        {role === "user" ? (
          <span className="user-icon" style={{ marginRight: "20px" }}>
            <img
              style={{
                borderRadius: "50%",
                height: "40px",
                width: "40px"
              }}
              src="https://placehold.it/50/55C1E7/fff&amp;text=USER"
              alt="User"
              className="img-circle"
            />
          </span>
        ) : (
          <span className="user-icon" style={{ fontSize: '25px', marginLeft: "15px", float: "right" }}>
            <img
              style={{
                borderRadius: "50%",
                height: "40px",
                width: "40px"
              }}
              src="https://placehold.it/50/55C1E7/fff&amp;text=BOT"
              alt="Bot"
              className="img-circle"
            />
          </span>
        )}
        <div className={role === "user" ? "message-out chat-message-da" : "message-in chat-message-da"}>
          {role === "user" ? content :
            <ReactMarkdown children={content ?? ""}
              components={{
                code({ node, inline, className, children, ...props }) {
                  const match = /language-(\w+)/.exec(className || "");
                  return !inline && match ? (
                    <CopyContent
                      subNode={children}
                      match={match}
                      properties={props}
                      style={oneDark}
                      node={node}
                    />
                  ) : (
                    <code className={className} {...props}>
                      {children}
                    </code>
                  );
                },
                img: (props) => (
                  <img className="img-responsive" src={`${props.src}?token=${localStorage.getItem('token')}`} alt={props.alt} width="100%" height="auto" />
                ),
                li: (props) => {
                  if (!props.children) {
                    return <></>;
                  }

                  return <li>{props.children.filter((elem) => elem !== '\n')}</li>;
                }
              }}
              remarkPlugins={[remarkGfm]} />
          }
          {(typing && (messageLength - 1) === index) && <p className="typing-parapraph">Typing...</p>}
        </div>
      </div>
    </div>
  );
};

export default memo(Message);
